// TODO: Dead Feature Whitening Premier
export default class PremierSlider {
  constructor({ $element: $element }) {
    this.$slider = $element;
    this.gtmType = "genre";
    this.showSlides = $element.data('show-slides') || 7;
  }

  init() {
    this.carousel();
  }

  getGtmType() {
    if(this.$slider.data('gtm-slider-type') == undefined) {
      return this.gtmType;
    }

    return this.$slider.data('gtm-slider-type');
  }

  isGtmEnable() {
    return this.$slider.filter('.js-gtm').length > 0;
  }

  carousel() {
    var gtmType = this.getGtmType();
    var gtmClass = this.isGtmEnable()? "js-gtm" : "";
    this.$slider.slick({
      arrows: true,
      speed: 800,
      cssEase: 'easeInOut',
      infinite: false,
      slidesToShow: this.showSlides,
      slidesToScroll: this.showSlides - 1,
      prevArrow: "<button type=\"button\" data-role=\"none\" class=\"slick-prev slick-arrow "+gtmClass+"\" aria-label=\"Prev\" role=\"button\" aria-disabled=\"false\" data-gtm-click=\"true\" data-gtm-evt=\"click\" data-gtm-name=\"genre\" data-gtm-loc=\"prev\" data-gtm-type=\""+ gtmType +"\" >Prev</button>",
      nextArrow: "<button type=\"button\" data-role=\"none\" class=\"slick-next slick-arrow "+gtmClass+"\" aria-label=\"Next\" role=\"button\" aria-disabled=\"false\" data-gtm-click=\"true\" data-gtm-evt=\"click\" data-gtm-name=\"genre\" data-gtm-loc=\"next\" data-gtm-type=\""+ gtmType +"\" >Next</button>",
    });
  }
}
